import { useAuth0 } from '@auth0/auth0-react';
import styles from './list.module.css';
import { useHistory } from "react-router-dom";
import { Edit, MoreVertical, Trash2, User, Users, X } from 'react-feather';
import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Dialog } from '@mui/material';

const MobileViewList = ({ rowsData, setSelectedId, setDeleteVehicleModalOpen, setEditModalOpen, setEditData }) => {
    const redirect = useHistory();
    const { user, isAuthenticated } = useAuth0();
    const [expandedMobileCardId, setExpandedMobileCardId] = useState(null);
    const [carImage, setCarImage] = useState("");
    const [openPop, setOpenPop] = useState(false);

    const goToDetails = (item) => {
        if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1) {
            setEditModalOpen(true);
            setEditData(item);
        } else {
            return false;
        }
    }

    return (<>
        <div className={`${styles.ListMobileView}`}>
            {rowsData.map((card) => {
                const isExpanded = expandedMobileCardId === card.id;
                const hasGuest = !!card.guest;

                return (<div key={card.id} className={`${styles.MobileVehicleCardWrapper}`} style={isExpanded ? { borderColor: '#C7D2FE' } : {}}>
                    <div className={`${styles.MobileVehicleMainCard}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setExpandedMobileCardId(isExpanded ? null : card.id); }}>

                        <div className={`${styles.MobileCarIconBox}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCarImage(card.image_path); setOpenPop(true); }}>
                            {card.image_thumbail_path ? <img src={card.image_path} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <img src="/static/img/car.svg" alt="" style={{ width: '40px', height: '40px', opacity: 0.7 }} />}
                            {card.isNew && (<span className={`${styles.MobileNewBadge}`}>New</span>)}
                        </div>

                        <div className={`${styles.MobileCardTextSec}`}>
                            <p className={`${styles.MobileCardTitle}`}>
                                <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + card.tenant_id); }}>{card.name}</span>
                            </p>
                            <p className={`${styles.MobileCardSub}`}>{card.license}</p>
                            <p className={`${styles.MobileCardSub}`}>{card.make} · {card.model} · {card.color}</p>
                            <p className={`${styles.MobileCardProp}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + card.property_id); }}>{card.property} · {card.unit}</p>
                        </div>

                        <div className={`${styles.MobileCardRightSec}`}>
                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                                    <MoreVertical />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(card); }}>
                                        <Edit /> Edit
                                    </Dropdown.Item>}
                                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(card?.id); }}>
                                        <Trash2 /> Delete
                                    </Dropdown.Item>}
                                </Dropdown.Menu>
                            </Dropdown>}

                            {hasGuest && (<div className={`${styles.MobileGuestCountBadge}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setExpandedMobileCardId(isExpanded ? null : card.id); }}>
                                <User />
                                <span>Guest</span>
                            </div>)}
                        </div>
                    </div>

                    {isExpanded && hasGuest && (<div className={`${styles.MobileGuestPanel}`}>
                        <div className={`${styles.MobileGuestPanelHeader}`}>
                            <span>GUEST VEHICLE</span>
                        </div>

                        <div className={`${styles.MobileGuestSubCard}`}>
                            <div className={`${styles.MobileCarIconBox}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCarImage(card.guest.image_path); setOpenPop(true); }}>
                                {card.guest.image_thumbail_path ? <img src={card.guest.image_thumbail_path} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <img src="/static/img/no-car.png" alt="" style={{ width: '40px', height: '40px', opacity: 0.6 }} />}
                            </div>

                            <div className={`${styles.MobileGuestText}`}>
                                <p className={`${styles.MobileGuestName}`}>{card.guest.name}</p>
                                <p className={`${styles.MobileGuestPhone}`}>{card.guest.phone}</p>
                                <span className={`${styles.MobileGuestLicenseBadge}`}>{card.guest.license}</span>
                                <p className={`${styles.MobileGuestCar}`}>{card.guest.make} {card.guest.model}</p>
                            </div>

                            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (<div className={`${styles.MobileGuestActions}`}>
                                <button className={`${styles.GuestActionBU}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); goToDetails(card.guest); }}>
                                    <Edit size={18} />
                                </button>
                                <button className={`${styles.GuestActionBU} ${styles.Delete}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteVehicleModalOpen(true); setSelectedId(card.guest.id); }}>
                                    <Trash2 size={18} />
                                </button>
                            </div>)}
                        </div>
                    </div>)}
                </div>);
            })}
        </div>

        <Dialog
            open={openPop}
            onClose={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenPop(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div className={`${styles.PopupImgSec}`}>
                <img src={carImage} alt="" />
                <button onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpenPop(false);
                }}><X /></button>
            </div>
        </Dialog>
    </>)
}

export default MobileViewList;